import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "absolute flex flex-grow w-full h-full bg-overlay opacity-70 z-10" }, null, -1)
const _hoisted_2 = ["data-splide-html-video"]
const _hoisted_3 = ["data-splide-lazy"]
const _hoisted_4 = ["data-splide-lazy", "alt"]
const _hoisted_5 = ["data-splide-lazy", "alt"]
const _hoisted_6 = ["data-splide-lazy", "alt"]
const _hoisted_7 = ["data-splide-lazy", "alt"]
const _hoisted_8 = {
  key: 4,
  class: "absolute flex flex-shrink w-auto h-16 bottom-10 left-1/4 sm:h-32 sm:bottom-0 sm:left-1/4 md:h-28 md:bottom-28 md:left-1/4 lg:h-40 xl:bottom-72 lg:left-1/4 z-20"
}
const _hoisted_9 = ["data-splide-lazy", "alt"]

export function render(_ctx: any,_cache: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!

  return (_openBlock(), _createBlock(_component_Splide, {
    options: _ctx.options,
    extensions: _ctx.extensions,
    "onSplide:created": _ctx.onSplideCreated,
    "onSplide:mounted": _ctx.onSplideMounted
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      (_ctx.cat !== '4' && _ctx.cat !== '6' && _ctx.cat !== '100')
        ? (_openBlock(), _createElementBlock("li", {
            key: 0,
            class: "splide__slide object-fill is-active is-visible h-200 sm:h-full",
            "data-splide-html-video": _ctx.sliderVideoId.sliderVideo+'#t=0.'
          }, [
            _createElementVNode("img", {
              class: "h-200 sm:h-full",
              style: {},
              "data-splide-lazy": require(`@/assets/slider${_ctx.catName}/slider-thumb.jpg`),
              alt: "jump sa slider"
            }, null, 8, _hoisted_3)
          ], 8, _hoisted_2))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliderContentByCat, (slide) => {
        return (_openBlock(), _createBlock(_component_SplideSlide, {
          key: slide,
          "data-splide-interval": 5000
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["absolute flex flex-grow w-full bg-overlay opacity-70", slide.title === 'Actors' ? 'hidden' : 'z-10 h-full'])
            }, null, 2),
            (_ctx.cat !== '6' && _ctx.cat !== '100' && slide.title !== 'Actors')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "",
                  "data-splide-lazy": require(`@/assets/${slide.image}`),
                  alt: slide.title
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (slide.title === 'Actors' && _ctx.cat !== '100')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: { name:'actors' }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      "data-splide-lazy": require(`@/assets/${slide.image}`),
                      alt: slide.title
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (_ctx.cat === '6')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  "data-splide-lazy": require(`@/assets/slider/casting/${ _ctx.$t('casting.slider.'+_ctx.sliderCat) }.jpg`),
                  alt: slide.title
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.cat === '100')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 3,
                  "data-splide-lazy": require(`@/assets/${slide.image}`),
                  alt: slide.title
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (slide.caption !== '' && _ctx.cat !== '100' && slide.title !== 'Actors')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("img", {
                    class: "object-contain md:object-fill w-full",
                    style: {"font-family":"'Oswald'"},
                    "data-splide-lazy": require(`@/assets/${ _ctx.$t(slide.caption)}`),
                    alt: slide.title
                  }, null, 8, _hoisted_9)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["options", "extensions", "onSplide:created", "onSplide:mounted"]))
}